import React, { Component, PropTypes } from 'react';
import idx from 'idx';
import { SubmissionError } from 'redux-form';
import ModalDialog from 'common/components/modal/modal_dialog';
import RequestForm from 'login/components/password_reset_request_form';
import { FORBIDDEN_INACTIVE_CODE } from 'account/constants';
import { sendPwdResetLinkRequest } from 'common/ducks/user';

/**
 * Password reset request modal.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class PasswordResetRequest extends Component {
  constructor(props) {
    super(props)

    this.state = {done: false}
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit(data) {
    return sendPwdResetLinkRequest(data)
      .then(() => this.setState({done: true}))
      .catch((res) => {
        /* field-specific errors */
        if (res.data) {
          if (res.data.email) {
            throw new SubmissionError({ email: res.data.email[0] });
          }
        }

        /* show appropriate banner if user is inactive */
        if (idx(res, _ => _.data.error_code) === FORBIDDEN_INACTIVE_CODE) {
          this.props.showInactiveBanner();
          throw new SubmissionError({ _error: 'Your account is inactive' });
        }

        /* global error */
        throw new SubmissionError({ _error: 'Unknown error. Please try again.' });
      })
  }

  render() {
    const { onClose } = this.props

    return (
      <ModalDialog modalOpen={true} dialogClasses="password-reset-request"
        modalHeader="Forgotten Password" closeAction={onClose}>

        {this.state.done?
        <div className="modal-done text-center">
          <h2 className="text-success"><i className="fa fa-check-circle"/><br/>Instructions Sent</h2>
          <p>Please check your email.</p>

          <div className="modal-actions">
            <button className="btn btn-tertiary" onClick={onClose}>Done</button>
          </div>
        </div>:
        <div>
          <p>
            Enter the email you used to create your account and we&apos;ll send you instructions to
            reset your password.
          </p>
          <RequestForm onSubmit={this.handleSubmit} onClose={onClose}/>
        </div>}

      </ModalDialog>
    )
  }
}
